export const orderKeys = (unorderedObj: IObjectAny) =>
  Object.keys(unorderedObj)
    .sort()
    .reduce((obj, key) => {
      obj[key] = unorderedObj[key]
      return obj
    }, {})
